import { ActionStatus } from "../../common/constants/action-status";
import { StoreState } from "../../store/store.interface";

/*----- CREATE SELECTORS ------*/

export const selectAbandonedCartPreference = (state: StoreState) => state.abandonedCartPreferenceState.data.status;
export const isAbandonedCartPreferenceLoaded = (state: StoreState) => [ ActionStatus.succeeded, ActionStatus.failed ].includes(state.abandonedCartPreferenceState.status);
